var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2488 0.00395327L11.785 0C9.01687 0 7.22802 1.8353 7.22802 4.67593V6.83184H4.7507C4.53663 6.83184 4.36328 7.00539 4.36328 7.21946V10.3431C4.36328 10.5572 4.53683 10.7306 4.7507 10.7306H7.22802V18.6126C7.22802 18.8267 7.40137 19 7.61544 19H10.8476C11.0617 19 11.2351 18.8265 11.2351 18.6126V10.7306H14.1316C14.3457 10.7306 14.519 10.5572 14.519 10.3431L14.5202 7.21946C14.5202 7.11667 14.4793 7.01824 14.4068 6.9455C14.3342 6.87276 14.2354 6.83184 14.1326 6.83184H11.2351V5.00424C11.2351 4.12583 11.4444 3.6799 12.5887 3.6799L14.2484 3.67931C14.4623 3.67931 14.6357 3.50576 14.6357 3.29189V0.391374C14.6357 0.177699 14.4625 0.0043486 14.2488 0.00395327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.596fc3da7d666a0a445deb5803ccc8e5.svg";
export { ForwardRef as ReactComponent };